// Package imports:
import React, { useState } from 'react';
// import ReCAPTCHA from 'react-google-recaptcha';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
// Component imports:
import Input from '../../../ui-elements/Input/Formik/Input';
import DropSelect from '../../../ui-elements/DropSelect/DropSelect';
import Button from '../../../ui-elements/Button/Button';
import Alert from '../../../ui-elements/Alert/Alert';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { IKeldanApiContact } from '../../../types/KeldanTypes';
import { Fetched } from '../../../types/Types';

const REASON_SUBSCRIPTION = 'Ég vil koma í áskrift að Vaktaranum';
const REASON_QUESTION = 'Fyrirspurn';

interface IFormProps {
    values: IFormValues
}
interface IFormValues {
    name: string,
    email: string,
    reason: string,
    message: string,
    // captcha: string
}


const VaktarinnContactForm: React.FC = () => {
    // Form state.
    // const [reason, setReason] = useState<string>(REASON_SUBSCRIPTION);
    // const [captchaValue, setCaptchaValue] = useState<string | null>(null);
    // Response state.
    const [contactResponse, setContactResponse] = useState<Fetched<string>>(null);
    const [loading, setLoading] = useState<boolean>(false)

    const handleSubmit = async (values: IFormValues, actions: any) => {
        // if (captchaValue === null) {
        //     setContactResponse(new Error('ReCAPTCHA krafa var ekki uppfyllt'));
        //     return;
        // }
        setLoading(true)
        try {
            setContactResponse(null);
            const requestQuery = new URLSearchParams({
                name: values.name,
                email: values.email,
                subject: values.reason,
                request: values.message
            });
            const url = `${GET_KELDAN_API_URL()}/Vaktarinn/Contact`;
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: requestQuery
            });
            if (response.ok) {
                const responseBody: IKeldanApiContact = await response.json();
                if (responseBody.success) {
                    setLoading(false)
                    setContactResponse(responseBody?.message || 'Fyrirspurn móttekin.');
                } else {
                    const { errors, message } = responseBody;
                    if (errors && errors.length > 0) {
                        setContactResponse(new Error(errors.join('\n')));
                    } else if (message) {
                        setContactResponse(new Error(message));
                    } else {
                        setContactResponse(new Error(ErrorMessages.ErrorInRequest));
                    }
                }
            } else {
                setLoading(false);
                setContactResponse(new Error(ErrorMessages.RequestFailed));
            }
        } catch (e) {
            setLoading(false);
            setContactResponse(new Error(ErrorMessages.NetworkError));
        }
    }


    const form: React.FC<IFormProps> = ({
        values
    }) => {
        return <Form>
                <div className="form__body">
                    <div className="form__row">
                        <div className="form__col">
                            <Input
                                label="Nafn"
                                name="name"
                                id="name"
                                value={values.name}
                            />
                        </div>
                        <div className="form__col">
                            <Input
                                label="Netfang"
                                name="email"
                                id="email"
                                value={values.email}
                            />
                        </div>
                    </div>
                    <div className="form__row">
                        <div className="form__col">
                            <DropSelect
                                options={[{
                                    label: REASON_SUBSCRIPTION,
                                    value: REASON_SUBSCRIPTION
                                }, {
                                    label: REASON_QUESTION,
                                    value: REASON_QUESTION
                                }]}
                                defaultValue={REASON_SUBSCRIPTION}
                                // onChange={(option) => { if (typeof option === 'string') setReason(option); }}
                                size='lg'
                            />
                        </div>
                    </div>
                    <div className="form__row">
                        <div className="form__col">
                            <Input
                                inputType="textArea"
                                label="Skilaboð"
                                name="message"
                                id="message"
                                value={values.message}
                            />
                        </div>
                    </div>
                    {(contactResponse === null)
                    ? null
                    : (
                        <div className="form__row">
                            <div className="form__col">
                                {(contactResponse instanceof Error)
                                ? <Alert type='error' headText={contactResponse.message} />
                                : <Alert type='info' headText={contactResponse} />}
                            </div>
                        </div>
                    )}
                    {/* <div className="form__row">
                        <div className="form__col">
                            <div className='captcha-wrapper'>
                                <ReCAPTCHA
                                    sitekey='6LfoC_gdAAAAAFD6ayXrdhV6Amw27mmqrlAPnatG'
                                    // onChange={value => setCaptchaValue(value)}
                                />
                            </div>
                        </div>
                    </div> */}
                </div>
                <div className="form__actions">
                    <Button type='submit' showLoader={loading} buttonType="primary" size="lg">Senda</Button>
                </div>
            </Form>
    }    
    return(
        <div className="KCL_notendur-form modal-form">
            <Formik
                initialValues={{
                    name: '',
                    email: '',
                    reason: '',
                    message: '',
                    // captcha: ''
                }}
                validationSchema={Yup.object({
                    name: Yup.string()
                        .required('Nafn má ekki vanta'),
                    email:  Yup.string()
                        .email('Ógilt netfang')
                        .required('Netfang verður að fylgja'),
                    reason: Yup.string(),
                    message: Yup.string()
                        .required("Skilaboð má ekki vanta"),
                    // captcha: Yup.string(),
                })}
                onSubmit={handleSubmit}
                component={form}
            />
        </div>
    )
}

export default VaktarinnContactForm;